export default "__VITE_ASSET__DKAklKQC__"